import React, { FunctionComponent } from 'react'
import { useWatch } from 'react-hook-form'
import { GreenBtn } from 'Stories/Button/Button.stories'
import { ButtonWrapper } from '../styles'
import { UploadButtonProps } from './types'

export const UploadButton: FunctionComponent<UploadButtonProps> = ({
  control,
  timeLeft,
  t,
  onClickUpload,
}) => {
  const url =
    control &&
    useWatch({
      control,
      name: 'url',
    })

  return (
    <ButtonWrapper>
      <GreenBtn
        // @ts-ignore
        type="submit"
        color={url || onClickUpload ? 'green' : 'grey'}
        // disabled={!onClickUpload}
        onClick={onClickUpload}
      >
        {t('influencer.uploadVideo')}
      </GreenBtn>
      <span>{timeLeft}</span>
    </ButtonWrapper>
  )
}
